export const SELEZIONA_PRODOTTO = "SELEZIONA_PRODOTTO";
//export const REQUEST_LOGIN = "REQUEST_LOGIN";
//export const RECEIVED_LOGIN = "RECEIVED_LOGIN";
export const SELEZIONA_UTENTE = "SELEZIONA_UTENTE";